import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import { AppConfig } from "../shared/utils/AppConfig.js";
import { ApiService } from "../shared/utils/ApiService.js";
import { Format } from "../shared/utils/Format.js";
import { InventariosService } from "../shared/services/InventariosService.js";
import { Navbar } from "../shared/components/navbar/Navbar.js";
import inventariosTemplate from "./templates/inventarios.html?raw";
import Swal from "sweetalert2";
import { confirmarBorrado } from "../shared/utils/Confirmar.js";
import { Sesion } from "../shared/utils/Sesion.js";

export const InventariosController = {
  // Destildado por default: sólo se muestran inventarios recientes (filtro por fecha en la API).
  mostrarAntiguos: false,

  render: async () => {
    const app = document.getElementById("app");
    app.innerHTML = Navbar.render("inventarios") + InventariosController.loaderHtml();
    Navbar.bind();

    try {
      const apiUrl = AppConfig.resolvedApiUrl();
      const todos = await InventariosService.listar(InventariosController.mostrarAntiguos);
      const activos = todos.filter((i) => i.activo);

      const inventarios = activos.map((i) => ({
        id: i.id,
        nombre: i.nombre,
        sucursalNombre: i.sucursal?.nombre || "—",
        fechaTxt: Format.fecha(i.fecha),
        xlsUrl: apiUrl + "/inventario-xls?id=" + i.id,
        puedeBorrar: Sesion.puedeEliminarInventario(),
      }));

      const content = TemplateEngine.render(inventariosTemplate, {
        inventarios,
        hayInventarios: inventarios.length > 0,
      });
      app.innerHTML = Navbar.render("inventarios") + content;
      Navbar.bind();
      InventariosController.bind();
    } catch (error) {
      console.error("Error cargando inventarios:", error);
      app.innerHTML = Navbar.render("inventarios") + InventariosController.errorHtml(error);
      Navbar.bind();
      document.getElementById("btnReintentar")?.addEventListener("click", InventariosController.render);
    }
  },

  bind: () => {
    const chkAntiguos = document.getElementById("chkAntiguos");
    if (chkAntiguos) {
      chkAntiguos.checked = InventariosController.mostrarAntiguos;
      chkAntiguos.addEventListener("change", (e) => {
        InventariosController.mostrarAntiguos = e.target.checked;
        InventariosController.render();
      });
    }

    document.getElementById("btnRefrescar")?.addEventListener("click", () => {
      ApiService.invalidate("inventarios");
      InventariosController.render();
    });

    document.getElementById("txtBuscar")?.addEventListener("keyup", (e) => {
      const criterio = e.target.value.toLowerCase();
      document.querySelectorAll("#tbodyInventarios tr").forEach((row) => {
        row.style.display = row.textContent.toLowerCase().includes(criterio) ? "" : "none";
      });
    });

    document.querySelectorAll(".btnBorrar").forEach((btn) => {
      btn.addEventListener("click", () => InventariosController.borrar(btn.dataset.id, btn.dataset.nombre, btn.dataset.sucursal));
    });
  },

  borrar: async (id, nombre, sucursal) => {
    const ok = await confirmarBorrado({
      titulo: "¿Borrar inventario?",
      html: "Vas a borrar el inventario <b>" + Navbar.esc(nombre) + "</b> (#" + Navbar.esc(id) + ")" +
        (sucursal ? " de <b>" + Navbar.esc(sucursal) + "</b>" : "") +
        ". Deja de aparecer en el listado junto con todo lo que se contó.",
    });
    if (!ok) return;

    try {
      await InventariosService.borrar(id);
      await Swal.fire({ icon: "success", title: "Eliminado", timer: 1200, showConfirmButton: false });
      InventariosController.render();
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo borrar: " + (error.message || "") });
    }
  },

  loaderHtml: () =>
    '<div class="loader-centro"><div class="spinner-border text-primary" role="status"></div></div>',

  errorHtml: (error) =>
    '<div class="container mt-3"><div class="alert alert-danger d-flex justify-content-between align-items-center">' +
    '<span><i class="fas fa-triangle-exclamation me-2"></i>' + (error.message || "Error al cargar") + "</span>" +
    '<button id="btnReintentar" class="btn btn-sm btn-outline-danger">Reintentar</button></div></div>',
};
